import React, { Suspense, lazy } from 'react';
import RedirectLoader from '../components/ShowLoader';

// Lazy load components
const Header = lazy(() => import('../components/landing/Header'));
const Hero = lazy(() => import('../components/landing/Hero'));
const Features = lazy(() => import('../components/landing/Features'));
const HowItWorks = lazy(() => import('../components/landing/HowItWorks'));
const Testimonials = lazy(() => import('../components/landing/Testimonials'));
const Pricing = lazy(() => import('../components/landing/Pricing'));
const Blog = lazy(() => import('../components/landing/Blog'));
const ContactForm = lazy(() => import('../components/landing/ContactForm'));
const WhatsAppButton = lazy(() => import('../components/landing/WhatsAppButton'));
const Footer = lazy(() => import('../components/landing/Footer'));

const FullPageLoader: React.FC = () => (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-950 z-[999]">
        <RedirectLoader text="Namaste 🙏, Welcome to Dinelyt" />
    </div>
);
const DinelytLandingPage: React.FC = () => {
    React.useEffect(() => {
        // Initialize CSS variable for header height
        document.documentElement.style.setProperty('--header-height', '75px');
        
        // Ensure scroll starts from top
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Suspense fallback={null}>
                <Header />
            </Suspense>

            <div style={{ paddingTop: 'var(--header-height, 75px)', transition: 'padding-top 0.4s ease-in-out' }} className="bg-black text-gray-100 min-h-screen">
                <Suspense fallback={<FullPageLoader />}>
                    <main>
                        <Hero />
                        <Features />
                        <HowItWorks />
                        <Testimonials />
                        <Pricing />
                        <Blog />
                        <ContactForm />
                    </main>
                    <WhatsAppButton />
                    <Footer />
                </Suspense>
            </div>
        </>
    );
};


export default DinelytLandingPage;